import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Direction,
  FloatMenuItemButton,
  FloatingGroup,
  Size,
} from "react-motion-float-button";
import OngoingListCard from "../../../../components/teacher/ongoing-list/OngoingListCard";
import { UserGroupIcon, UserIcon } from "@heroicons/react/solid";
import { fetchOngoingProjectList } from "./api-handlers";
import routes from "../../../../config/routes-config.js";

const OngoingProjectsList = () => {
  const [ongoingProjectList, setOngoingProjectList] = useState({
    EDAI: [],
    SDP: [],
  });

  const [userAuth] = useState(() => {
    const user = sessionStorage.getItem("auth");
    if (user !== null) {
      return JSON.parse(user);
    }
    return null;
  });

  const navigate = useNavigate();

  useEffect(() => {
    if (userAuth !== null) {
      fetchOngoingProjectList(
        `${routes.teacher.ongoingProjects.ongoingProjectListUrl}?teacherId=${userAuth.userName}`,
        userAuth.token,
        setOngoingProjectList
      );
    }
  }, [userAuth]);

  const handleRouteToCreateNewProject = (typeOfProject) => {
    if (typeOfProject === "EDAI") {
      navigate("/teacher/ongoing-projects/create-new-edai-project");
    } else if (typeOfProject === "SDP") {
      navigate("/teacher/ongoing-projects/create-new-sdp-project");
    }
  };

  return (
    <>
      <div className="flex flex-col bg-[#ECECEC] w-full px-10 justify-evenly">
        <h1 className="text-3xl font-semibold">Ongoing Project</h1>
        <div className="flex flex-col place-items-center sm:flex-row sm:flex-wrap justify-evenly place-content-center">
          <div className="h-[calc(100vh-15rem)] w-1/3 rounded-2xl bg-white border-[#B2B7FF] border-2 p-4">
            <h1 className="text-[#1C42D5] text-2xl font-semibold justify-left my-3 ml-4">
              EDAI
            </h1>
            <div className="flex flex-col items-center mt-4">
              <div className="flex w-full border-t border-[#B3B7C6] border-2"></div>
            </div>
            <div className="overflow-y-scroll overflow-x-clip w-auto h-[calc(100vh-23rem)] justify-items-center">
              {ongoingProjectList.EDAI.filter(
                (edaiProject) => edaiProject.title.trim() !== ""
              ).map((edaiProject, index) => (
                // TODO :: please Add the correct projectId parameter here
                <Link
                  key={index}
                  to={`/teacher/ongoing-projects/edai/project-details/${edaiProject.projectId}`}
                >
                  <OngoingListCard key={index} project={edaiProject} />
                </Link>
              ))}

              {/* TODO :: Please remove this after work is done */}
              {ongoingProjectList.EDAI.map((edaiProject, index) => (
                // TODO :: please Add the correct projectId parameter here
                <Link
                  key={index}
                  to={`/teacher/ongoing-projects/edai/project-details/${edaiProject.projectId}`}
                >
                  <OngoingListCard key={index} project={edaiProject} />
                </Link>
              ))}
            </div>
          </div>
          <div className="h-[calc(100vh-15rem)] w-1/3 rounded-2xl bg-white border-[#B2B7FF] border-2 p-4">
            <h1 className="text-[#1C42D5] text-2xl font-semibold justify-left my-3 ml-4">
              SDP
            </h1>
            <div className="flex flex-col items-center mt-4">
              <div className=" flex w-full border-t border-[#B3B7C6] border-2"></div>
            </div>
            <div className="overflow-y-scroll overflow-x-clip w-auto h-[calc(100vh-23rem)] justify-items-center">
              {ongoingProjectList.SDP.filter(
                (sdpProject) => sdpProject.title.trim() !== ""
              ).map((sdpProject, index) => (
                // TODO :: please Add the correct projectId parameter here
                <Link
                  key={index}
                  to={`/teacher/ongoing-projects/sdp/project-details/${sdpProject.projectId}`}
                >
                  <OngoingListCard project={sdpProject} />
                </Link>
              ))}

              {/* TODO :: Please remove this after work is done */}
              {ongoingProjectList.SDP.map((sdpProject, index) => (
                // TODO :: please Add the correct projectId parameter here
                <Link
                  key={index}
                  to={`/teacher/ongoing-projects/sdp/project-details/${sdpProject.projectId}`}
                >
                  <OngoingListCard project={sdpProject} />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="absolute -bottom-10 right-0">
        <FloatingGroup
          size={Size.REGULAR}
          direction={Direction.TOP}
          spacing={100}
        >
          <FloatMenuItemButton
            icon={
              <div className="flex flex-col justify-center">
                <UserIcon className="h-6" />
                <h1>SDP</h1>
              </div>
            }
            buttonColor="#00ACEE"
            onClick={() => handleRouteToCreateNewProject("SDP")}
          />
          <FloatMenuItemButton
            icon={
              <div className="flex flex-col justify-center">
                <UserGroupIcon className="h-6" />
                <h1>EDAI</h1>
              </div>
            }
            buttonColor="#4f5bd5"
            onClick={() => handleRouteToCreateNewProject("EDAI")}
          />
        </FloatingGroup>
      </div>
    </>
  );
};

export default OngoingProjectsList;
